import {Navigate} from "react-router-dom";
import {MarketingComponent} from "../components/MarketingComponent";
import {useUserAttributes} from "../../../hooks/useUserAttributes.ts";


export const PublicHomePage = () => {

    const {email} = useUserAttributes();

    if (email) {
        return <Navigate to={'/messages/status/inbox'}/>;
    } else {
        return <MarketingComponent/>;
    }

};
